import { render, staticRenderFns } from "./IntegralDetails.vue?vue&type=template&id=8ec1d87e&"
import script from "./IntegralDetails.vue?vue&type=script&lang=js&"
export * from "./IntegralDetails.vue?vue&type=script&lang=js&"
import style0 from "./IntegralDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports